import React from 'react';
import { motion } from 'framer-motion';
import { JaliDivider } from './JaliDivider';
import { useLanguage } from '../lib/LanguageContext';
export function OurVision() {
  const {
    t,
    tArray
  } = useLanguage();
  const phases = tArray<{
    num: string;
    title: string;
    desc: string;
  }>('ourVision.phases');
  return <section className="relative py-32 md:py-40 flex items-center justify-center overflow-hidden min-h-screen" data-id="element-144">
      {/* Full Background Video */}
      <div className="absolute inset-0 z-0 bg-navy overflow-hidden" data-id="element-145">
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover scale-[1.35] origin-center opacity-100" data-id="element-146">
          <source src="https://cdn.magicpatterns.com/uploads/pMbz92XDCwP7HwZ1xnNPZC/gurdwaraoutside.mp4" type="video/mp4" data-id="element-147" />
        </video>
      </div>

      {/* Cinematic Gradients & Overlay */}
      <div className="absolute inset-0 z-10 bg-gradient-to-br from-navy/50 via-navy/30 to-black/50" data-id="element-148" />
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-navy/90 via-transparent to-navy/90" data-id="element-149" />

      <div className="relative z-20 max-w-7xl mx-auto px-6 md:px-12 w-full" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-3xl mx-auto mb-24" data-id="element-151">
          <h2 className="text-4xl md:text-6xl font-heading text-warmWhite mb-4 drop-shadow-lg" data-id="element-152">
            {t('ourVision.title')}
          </h2>
          <p className="text-saffron tracking-widest uppercase text-sm font-semibold mb-6 drop-shadow-md" data-id="element-153">
            {t('ourVision.subtitle')}
          </p>
          <div className="w-16 h-[2px] bg-saffron mx-auto" data-id="element-154" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 relative" data-id="element-155">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-8 left-0 w-full h-[1px] bg-saffron/30 z-0" data-id="element-156" />

          {phases.map((phase, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className="bg-navy/60 backdrop-blur-lg border border-warmWhite/20 p-8 rounded-sm text-center relative group hover:bg-navy/80 hover:border-saffron/50 transition-all duration-500 shadow-2xl" data-id="element-157">
              {/* Number Badge */}
              <div className="w-16 h-16 mx-auto bg-navy/90 backdrop-blur-xl border border-saffron/50 rounded-full flex items-center justify-center mb-8 -mt-16 group-hover:-translate-y-2 transition-transform duration-500 shadow-lg" data-id="element-158">
                <span className="font-heading text-2xl text-saffron" data-id="element-159">
                  {phase.num}
                </span>
              </div>

              <h3 className="font-heading text-2xl text-warmWhite mb-4 drop-shadow-md" data-id="element-160">
                {phase.title}
              </h3>
              <p className="text-warmWhite/90 leading-relaxed text-sm font-medium" data-id="element-161">
                {phase.desc}
              </p>
            </motion.div>)}
        </div>
      </div>

      <JaliDivider className="absolute bottom-0 left-0 translate-y-1/2 z-30 opacity-50" data-id="element-162" />
    </section>;
}